import React from "react";
import { Icon } from "components";
import { titleCase } from "utils";
import { WpWebAppSettings_Webappsettings } from "codegen";
import "../SocialLinks.scss";
import { graphql, useStaticQuery } from "gatsby";

interface SocialLinksComponent {
  data: WpWebAppSettings_Webappsettings;
}

interface SocialLinks {
  passedData?: { type: string; url: string }[];
}

const SocialLinksComponent = ({ data }: SocialLinksComponent): JSX.Element => {
  if (!data) return null;

  return (
    <div className="social-links">
      {Object.keys(data).length > 0 &&
        data?.map((item, index) => {
          return (
            <a href={item.url} target="_blank" rel="noopener noreferrer" key={index}>
              <Icon name={titleCase(item.type)} />
            </a>
          );
        })}
    </div>
  );
};

/**
 * Social links component - will be used to link to external sites
 * If data is passed to it it will return those items, if not it will return the social links from the app settings
 *
 * @returns Component displaying the external social media links which are set in App Settings (WP)
 *
 */
export const SocialsLinks = ({ passedData }: SocialLinks): JSX.Element => {
  const data = useStaticQuery(graphql`
    query SocialLinks {
      wp {
        webAppSettings {
          webAppSettings {
            socialLinks {
              type
              url
            }
          }
        }
      }
    }
  `);
  return <SocialLinksComponent data={passedData || data.wp.webAppSettings.webAppSettings.socialLinks} />;
};
